<template>
    <div>
        <b-modal ref="modal-ajuste-tramo3" title="AJUSTAR IMPORTE VIAJE (250-980KM)" modal-class="modal-primary" hide-footer
            @hidden="$emit('close')" size="md" no-close-on-backdrop no-close-on-esc>

            <ValidationObserver ref="ref-validation-ajuste-tramo3">
                <b-row>
                    <b-col md="12" class="mb-2">
                        <div class="d-flex gap-x-3">
                            <span class="text-warning">Viaje: <b>{{ modalData.viaje || '-' }}</b></span>
                            <span class="text-warning">Orden: <b>{{ modalData.orden || '-' }}</b></span>
                        </div>
                        <div class="d-flex" v-if="modalData.cliente">
                            <span>Cliente: {{ modalData.cliente }}</span>
                        </div>
                        <div class="d-flex" v-if="modalData.ruta">
                            <span>Ruta: {{ modalData.ruta }}</span>
                        </div>
                        <div class="d-flex gap-x-3 mt-50">
                            <span v-if="modalData.km">Km: <b>{{ modalData.km }} km</b></span>
                            <span v-if="modalData.tipo_servicio">Tipo: <b>{{ modalData.tipo_servicio }}</b></span>
                        </div>
                        <div class="d-flex gap-x-3 mt-1">
                            <span>Monto original: <b class="text-secondary">S/ {{ modalData.monto_original | currency }}</b></span>
                            <span v-if="modalData.monto_ajustado !== null && modalData.monto_ajustado !== undefined">
                                Monto actual: <b class="text-primary">S/ {{ modalData.monto_calculado | currency }}</b>
                            </span>
                        </div>
                    </b-col>

                    <b-col lg="12" md="12">
                        <validation-provider v-slot="{ errors }" name="monto ajustado"
                            rules="required|min_value:0">
                            <b-form-group label="Nuevo importe del viaje (S/)" label-for="monto_ajustado"
                                :state="errors[0] ? false : null">
                                <money id="monto_ajustado" v-model="form.monto_ajustado" v-bind="moneyConfig"
                                    class="form-control w-100 form-control-md" />
                            </b-form-group>
                        </validation-provider>
                    </b-col>

                    <b-col md="12" lg="12">
                        <ValidationProvider v-slot="{ errors }" rules="required|max:400" name="motivo">
                            <b-form-group label="Motivo del ajuste" label-for="motivo_ajuste"
                                :state="errors[0] ? false : null">
                                <b-form-textarea id="motivo_ajuste" v-model="form.motivo_ajuste" rows="3"
                                    placeholder="Ingrese el motivo del ajuste del importe..."
                                    :class="{ 'border-danger': errors[0] }" />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                </b-row>
            </ValidationObserver>

            <div class="text-center mt-1">
                <b-button variant="outline-success" @click="guardarAjuste">GUARDAR AJUSTE</b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import modalMixin from "@/mixins/modal";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import BonoService from "@/views/rrhh/views/payroll/components/bonos/service/bono.service.js";

export default {
    mixins: [modalMixin],
    props: {
        modalData: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            moneyConfig: {
                decimal: ".",
                thousands: ",",
                prefix: "S/. ",
                precision: 2,
                masked: false,
            },
            form: {
                monto_ajustado: 0,
                motivo_ajuste: null,
            },
        };
    },
    mounted() {
        this.toggleModal("modal-ajuste-tramo3");

        const tieneAjuste = this.modalData.monto_ajustado !== null && this.modalData.monto_ajustado !== undefined;
        this.form.monto_ajustado = tieneAjuste
            ? Number(this.modalData.monto_ajustado)
            : Number(this.modalData.monto_original);
        this.form.motivo_ajuste = this.modalData.motivo_ajuste || null;
    },
    methods: {
        async guardarAjuste() {
            try {
                const result = await this.$refs["ref-validation-ajuste-tramo3"].validate();
                if (!result) return;

                const confirm = await this.showConfirmSwal();
                if (!confirm.isConfirmed) return;

                this.addPreloader();

                const { data } = await BonoService.ajustarTramo3({
                    id: this.modalData.id,
                    monto_ajustado: Number(this.form.monto_ajustado),
                    motivo_ajuste: this.form.motivo_ajuste,
                });

                this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                        title: this.$t(data.message),
                        icon: "CheckCircleIcon",
                        variant: "success",
                        text: this.$t(data.message),
                    },
                });

                this.$emit("refresh");
            } catch (error) {
                this.showToastError(error?.response?.data?.message);
            } finally {
                this.removePreloader();
            }
        },
    },
};
</script>
